import { View } from "ui/atoms/view";
import GoBack from "ui/molecules/common/GoBack";
import { usePathname } from "expo-router";
import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { ButtonIcon, ButtonLink, ButtonText } from "ui/gluestack/button";
import { AddIcon } from "ui/gluestack/icon";
import {
  FormEnums,
  NewFormButtonText,
} from "app/services/api/types/forms/enums/FormEnums";
import { AssessmentHistoryTemplate } from "app/features/reporting/templates/AssessmentHistoryTemplate";

export function AccidentsIncidentsScreen() {
  const pathname = usePathname();

  const { resident } = useResidentContext();
  const newPath = pathname.split("/").slice(0, -1).join("/");

  return (
    <View className="resident-container">
      <View className="flex-row justify-between mb-4">
        <GoBack path={newPath} />
        {resident?.id && (
          <PermissionCheck permission={PermissionsEnums.FILL_FORM}>
            <ButtonLink
              href={`/residents/${resident?.id}/accidents-and-incidents/add`}
            >
              <ButtonIcon as={AddIcon} />
              <ButtonText>
                {NewFormButtonText[FormEnums.ACCIDENTS_INCIDENTS]}
              </ButtonText>
            </ButtonLink>
          </PermissionCheck>
        )}
      </View>
      <AssessmentHistoryTemplate
        tag={FormEnums.ACCIDENTS_INCIDENTS}
        residentId={resident?.id}
      />
    </View>
  );
}
